var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.localShow)?_c('div',[_c('b-progress',{staticClass:"loader",attrs:{"max":1}},[_c('b-progress-bar',{attrs:{"variant":"info","value":1,"stripped":"","animated":""}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }